import { createAsyncThunk } from '@reduxjs/toolkit';
import createApiFromState from 'api/createApiFromState';

const pathwayDownload = createAsyncThunk(
  'pathway/download',
  async ({ input, locations, locationType }, { dispatch, getState }) => {
    const api = createApiFromState({ dispatch, getState });
    const response = await api.post(`/api/pathways/download`, {
      input,
      locations,
      location_type: locationType,
    });

    window.location = response.data.url;
  },
);

export { pathwayDownload };
